export let commonStyle = {
  title: "",
  bgColor: "#ffffff",
  textColor: "#404040",
  fontFamily: "Calibri",
  fontSize: window.innerWidth < 768 ? 20 : 24,
  fontStyle: "normal",
  fontWeight: 400,
};
